import { render, staticRenderFns } from "./JobGrade.vue?vue&type=template&id=5837eda6"
import script from "./JobGrade.vue?vue&type=script&lang=js"
export * from "./JobGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports